import { Navigate, useParams } from 'react-router-dom';

import { CaseStudy } from '../../components/portfolio/case-study';
import { worksBySlug } from '../../content';

export const Work = () => {
  const { slug } = useParams();
  const work = slug ? worksBySlug[slug] : undefined;

  if (!work) {
    return <Navigate to="/our-works" replace />;
  }

  return <CaseStudy entry={work} parent={{ name: 'Our works', path: '/our-works' }} />;
};
